import { Checkbox, FormControlLabel, Typography } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  ListCard,
  ListCardSubtitle,
  ListCardTitle,
} from '../../../../common/components/cards';
import { styles } from '../../../../common/styles/styles';
import { UserDto } from '../../users.dtos';

interface IProps {
  user: UserDto;
}

const UserListItem: React.FC<IProps> = ({ user }) => {
  const history = useHistory();

  const onClick = () => history.push(`/users/${user.id}`);

  return (
    <ListCard
      // eventClick={() => handleSelectedIndex(index)}
      onClick={onClick}
      title={
        <ListCardTitle
          title={`${user.firstName} ${user.lastName}`}
          statuses={[]}
        />
      }
      subtitles={[
        <ListCardSubtitle title='Phone' data={user.phoneNumber} />,
        <ListCardSubtitle title='Email' data={user.email} />,
      ]}
      actionbutton={
        <FormControlLabel
          value={user.isActive}
          control={
            <Checkbox
              size='small'
              color='primary'
              checked={user.isActive}
              inputProps={{ readOnly: true }}
            />
          }
          label={
            <Typography style={styles.formControlLabel}>Active</Typography>
          }
          labelPlacement='top'
        />
      }
    />
  );
};

export default UserListItem;
